import Parse from "parse";

Parse.initialize("asew-rechnung");
Parse.serverURL = "https://parse-asew-rechnung.prod.openinc.de/parse";
